import React, { useEffect, useRef } from 'react'
import { useGLTF, PerspectiveCamera, useAnimations } from '@react-three/drei'
import * as THREE from 'three';

const Engineer = (props) => {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/engineer.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    if (actions) {
        Object.values(actions).forEach(action => {
            action.reset().play();
            action.setLoop(THREE.LoopRepeat);
        });
    }
}, [actions]); 
  
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <PerspectiveCamera
          name="Camera"
          makeDefault={true}
          zoom={1}
          far={100}
          near={0.1}
          fov={25.377}
          position={[-2.51, 2.2, 15]}
          rotation={[-0.054, 0.009, 0.001]}
        />
        <group name="Armature" rotation={[Math.PI / 2, 0, 0]} scale={2.2}>
          <group name="Body">
            <skinnedMesh
              name="Bodymesh"
              geometry={nodes.Bodymesh.geometry}
              material={materials['Material.003']}
              skeleton={nodes.Bodymesh.skeleton}
            />
            <skinnedMesh
              name="Bodymesh_1"
              geometry={nodes.Bodymesh_1.geometry}
              material={materials.Material}
              skeleton={nodes.Bodymesh_1.skeleton}
            />
          </group>
          <skinnedMesh
            name="Cube001"
            geometry={nodes.Cube001.geometry}
            material={materials.Material}
            skeleton={nodes.Cube001.skeleton}
          />
          <skinnedMesh
            name="Face"
            geometry={nodes.Face.geometry}
            material={materials['Material.001']}
            skeleton={nodes.Face.skeleton}
          />
          <primitive object={nodes.mixamorigHips} />
        </group>
        <mesh
          name="Plane"
          castShadow
          receiveShadow
          geometry={nodes.Plane.geometry}
          material={materials['Material.002']}
          position={[0, 3.089, -4.511]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={5.454}
        />
        
        <group
          name="Schermo"
          position={[1.986, 2.828, 0]}
          rotation={[-0.036, -0.504, -0.258]}
          scale={[1, 1, 0.189]}>
          <mesh
            name="Cube001_1"
            castShadow
            receiveShadow
            geometry={nodes.Cube001_1.geometry}
            material={materials['Material.004']}
          />
          <mesh
            name="Cube001_2"
            castShadow
            receiveShadow
            geometry={nodes.Cube001_2.geometry}
            material={materials['Material.005']}
          />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/engineer.glb')

export default Engineer